import { NetworkDashboardWidgetType } from '../../../../admin/networks/dashboard/widgetModel';
import { DashboardCanvas } from '@/components/dashboard/DashboardCanvas';
import { DashboardDateControl } from '@/components/dashboard/DashboardDateControl';

import { dashboardT } from '../../../../../lib/messages';
import { networkDashboardWidgetRegistry } from '../../../../admin/networks/dashboard/widgetRegistry';
import { defaultPublisherDetailsDashboardDocument } from '../../defaultPublisherDetailsDashboard';
import { usePublisherDetailsDashboardQueries } from '../../hooks';
import { usePublisherDashboardRouteFilters } from '../../usePublisherDashboardRouteFilters';

export function PublisherDetailsDashboardContent({ publisherId }: { publisherId: string }) {
  const { range, setRange } = usePublisherDashboardRouteFilters(true);
  const queries = usePublisherDetailsDashboardQueries(publisherId, range);

  return (
    <div className="min-w-0 space-y-6">
      <section className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-lg font-semibold">
          {dashboardT('networkDashboard.performanceOverview')}
        </h2>
        <DashboardDateControl
          showDayNavigation={range.dateFrom === range.dateTo}
          value={range}
          onChange={setRange}
        />
      </section>
      <DashboardCanvas
        document={{
          ...defaultPublisherDetailsDashboardDocument,
          widgets: defaultPublisherDetailsDashboardDocument.widgets.filter(
            (widget) => range.preset || widget.type !== NetworkDashboardWidgetType.PerformanceChart,
          ),
        }}
        registry={networkDashboardWidgetRegistry}
        runtime={{ range, ...queries }}
      />
    </div>
  );
}
